import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="completion"
export default class extends Controller {
  static targets = ["count", "button"]
  static values = { 
    itemType: String, 
    itemId: Number, 
    date: String,
    url: String
  }

  connect() {
    console.log("Completion controller connected", {
      itemType: this.itemTypeValue,
      itemId: this.itemIdValue,
      date: this.dateValue,
      url: this.urlValue
    })
  }

  increment(event) {
    event.preventDefault()
    
    console.log("Increment clicked", {
      itemType: this.itemTypeValue,
      itemId: this.itemIdValue,
      date: this.dateValue,
      url: this.urlValue
    })
    
    const button = event.currentTarget
    const originalText = button.innerHTML
    
    // Disable button and show loading state
    button.disabled = true
    button.innerHTML = '<i class="bi bi-hourglass-split"></i>'
    
    const requestBody = {
      item_type: this.itemTypeValue,
      item_id: this.itemIdValue,
      date: this.dateValue
    }

    console.log("Sending request to:", this.urlValue, "with body:", requestBody)

    fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
      },
      body: JSON.stringify(requestBody)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return response.json()
    })
    .then(data => {
      if (data.success) {
        // Update count with animation
        this.updateCount(data.new_count)
        
        // Show success feedback
        this.showSuccess()
        
        // Dispatch custom event for dashboard updates
        this.dispatch("updated", { 
          detail: { 
            itemType: this.itemTypeValue,
            itemId: this.itemIdValue,
            newCount: data.new_count 
          } 
        })
        
        // Also trigger a global event for dashboard controller
        document.dispatchEvent(new CustomEvent('completion:updated', {
          detail: {
            itemType: this.itemTypeValue,
            itemId: this.itemIdValue,
            newCount: data.new_count
          }
        }))
      } else {
        throw new Error(data.error || 'Unknown error')
      }
    })
    .catch(error => {
      console.error('Error:', error)
      this.showError(error.message)
    })
    .finally(() => {
      // Re-enable button
      button.disabled = false
      button.innerHTML = originalText
    })
  }

  updateCount(newCount) {
    if (this.hasCountTarget) {
      const countElement = this.countTarget
      const oldCount = parseInt(countElement.textContent)
      
      // Animate count change
      countElement.style.transform = 'scale(1.2)'
      countElement.style.transition = 'transform 0.2s ease-in-out'
      
      setTimeout(() => {
        countElement.textContent = newCount
        countElement.style.transform = 'scale(1)'
        
        // Add color flash effect
        const originalClass = countElement.className
        countElement.className = originalClass.replace(/text-\w+/, 'text-primary')
        
        setTimeout(() => {
          countElement.className = originalClass
        }, 300)
      }, 100)
    }
  }

  showSuccess() {
    // Add success animation to button
    if (this.hasButtonTarget) {
      this.buttonTarget.classList.add('btn-outline-success')
      setTimeout(() => {
        this.buttonTarget.classList.remove('btn-outline-success')
      }, 500)
    }
  }

  showError(message) {
    // Show error feedback
    const alert = document.createElement('div')
    alert.className = 'alert alert-danger alert-dismissible fade show position-fixed'
    alert.style.cssText = 'top: 20px; right: 20px; z-index: 9999; max-width: 300px;'
    alert.innerHTML = `
      ${message}
      <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
    `
    document.body.appendChild(alert)
    
    // Auto-remove after 5 seconds
    setTimeout(() => {
      if (alert.parentNode) {
        alert.remove()
      }
    }, 5000)
  }
}
